export enum FileImportType {
  PRODUCT_BIN_QTY = 'product_bin_qty',
  PRODUCT_CATEGORY_PRIORITIZATION = 'product_category_prioritization',
  PHARMACY_COPY_INVOICE_FLAG = 'pharmacy_copy_invoice_flag',
  ADD_USER = 'add_user',
  DELETE_USER = 'delete_user',
  PRODUCT_DIMENSION = 'product_dimension',
  BIN = 'bin',
}
